import {Link, useLocation, useNavigate} from 'react-router-dom';
import {Button, NotFound} from '@kroll-resolver-crisp/ui-components-react';
import {pageTitle} from '@/lib/documentTitle';
import {DEFAULT_ROUTE} from '@/lib/platform';

const HOME_LABEL = `Go to ${pageTitle(DEFAULT_ROUTE) ?? 'home'}`;

// The design system's in-shell 404: the sidebar and header stay, only the content area says the
// link was bad. Rendered for an unmatched path inside the authenticated shell, which used to
// redirect silently to DEFAULT_ROUTE - hiding broken links rather than letting anyone report them.
export function PageNotFound() {
  const navigate = useNavigate();
  // `default` is the key of the history entry the app was loaded on, so there is nothing in-app to
  // go back to: a fresh tab opened on a bad link would otherwise step back out of PRI entirely.
  const canGoBack = useLocation().key !== 'default';

  return (
    <div className="flex h-full items-center justify-center p-6">
      <NotFound
        actions={
          <>
            <Button render={<Link to={DEFAULT_ROUTE} />}>{HOME_LABEL}</Button>
            {canGoBack ? (
              <Button variant="secondary" onClick={async () => navigate(-1)}>
                Go back
              </Button>
            ) : null}
          </>
        }
      />
    </div>
  );
}
